import React from "react";
import { ExchangeType } from "../constants";

export default ({ exchangeType, currencyPair }) => (
  <a href={chartUrl(exchangeType, currencyPair)} target={exchangeType + "_" + currencyPair}>
    {currencyPair.replace(/null/i, "*")}
  </a>
);

export function chartUrl(exchangeType, currencyPair) {
  switch (exchangeType) {
    case ExchangeType.POLONIEX:
      return "https://poloniex.com/exchange/#" + currencyPair.replace(/null/i, "*").replace(/(\w+)\/(\w+)/g, "$2_$1");
    case ExchangeType.BINANCE:
      return "https://www.binance.com/trade.html?symbol=" + currencyPair.replace(/null/i, "*").replace("/", "_");
    case ExchangeType.BITTREX:
      return (
        "https://bittrex.com/Market/Index?MarketName=" +
        currencyPair.replace(/null/i, "*").replace(/(\w+)\/(\w+)/g, "$2-$1")
      );
    default:
      return "";
  }
}



// WEBPACK FOOTER //
// ./src/components/CurrencyPair.js